import React, { useState, useEffect } from "react";
import $ from "jquery";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import { StyledMenu } from "../../../application/analytics/styled";
import { PeriodItemComponent } from "../../../application/analytics/common";
import { Stack, Typography, Grid, Box } from "@mui/material";
import { GreenTimeRangePicker } from "../../../../common/Greens";
import LayerdIcon from "../../../../common/LayerdIcon";
import { DETECTION_ICONS } from "../../../../../icons/detectionLucideIcons";
import BotScoreStatsChart from "./components/WAFDetectionInsight";

import WorldVectorMap from "../../overview/components/WorldVectorMap";
import { PanelSkeleton, DashboardPanelEmptyState } from "../web_application/Dashboard";

import colors from "../../../../../utils/colors";
import V2PageHeader from "../../../../common/V2PageHeader";
import SiteScopeGate from "../../../../common/SiteScopeGate";
import { displayUserAgent } from "../../../../../utils/display";
import useAuth from "../../../../../hooks/useAuth";
import useBMConfig from "../../../../../hooks/user/useBMConfig";
import useHome from "../../../../../hooks/user/useHome";
import useGlobalSite from "../../../../../hooks/user/useGlobalSite";
import {
  buildBotEventFiltersFromDashboardCard,
  DASHBOARD_TOP_CARD_LIMIT,
} from "../../detection/dashboardEventNavigation";
import { formatBrowserTimezoneOffset } from "../../../../../utils/timeRange";

const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

const NewServicesBotDashboard = () => {
  const navigate = useNavigate();
  const {
    isAuthenticated,
    homeController,
    wafdashController,
    websiteController,
    wafeventController,
    planController,
    setWafDashController,
    setWafEventController,
  } = useAuth();
  const { map_region, top_source, top_path, top_ua, top_method, top_ja3_hash, top_region, top_host, getDashboardInfo, getBotScoreStats } =
    useBMConfig();
  const { curProjectId } = useHome();
  const { apiSiteId: siteID } = useGlobalSite();

  const [timeRange, setTimeRange] = useState("7d");
  const [customRangeConfirm, setCustomRangeConfirm] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [customDateRange, setCustomDateRange] = useState(["2000-01-01T00:00:00", "2000-01-02T00:00:00"]);

  useEffect(() => {
    const now = new Date();
    const oneDayAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const date = String(now.getDate()).padStart(2, "0");
    const year = String(now.getFullYear());
    const _month = String(oneDayAgo.getMonth() + 1).padStart(2, "0");
    const _date = String(oneDayAgo.getDate()).padStart(2, "0");
    const _year = String(oneDayAgo.getFullYear());
    setCustomDateRange([_year + "-" + _month + "-" + _date + "T00:00:00", year + "-" + month + "-" + date + "T00:00:00"]);
  }, []);

  const selectPeriod = (period) => {
    setAnchorEl(null);
    setTimeRange(period);
    if (period === "custom") {
      $(document).ready(function () {
        $(".react-minimal-datetime-range__range-input-wrapper").click();
        $(".react-minimal-datetime-range").css({
          "margin-top": $(".react-minimal-datetime-range__range-input-wrapper").parent().parent().parent().height() + 4,
        });
      });
    }
  };
  const selectCustomDateRange = (res) => {
    setCustomRangeConfirm(true);
    setCustomDateRange(res);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getTimeRange = () => {
    if (timeRange === "custom") {
      return {
        time_zone: formatBrowserTimezoneOffset(),
        from: customDateRange[0],
        to: customDateRange[1],
      };
    } else {
      return { period: timeRange };
    }
  };

  useEffect(() => {
    if (!isAuthenticated) return;
    if (timeRange === "custom" && customRangeConfirm === false) {
      return;
    }
    setCustomRangeConfirm(false);
    if (homeController) homeController.abort();
    if (wafdashController) wafdashController.abort();
    if (websiteController) websiteController.abort();
    if (wafeventController) wafeventController.abort();
    if (planController) planController.abort();
    if (siteID) {
      getDashboardInfo(setWafDashController, siteID, getTimeRange(), 5);
    }
  }, [isAuthenticated, siteID, timeRange, customDateRange, curProjectId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!isAuthenticated) return;
    if (timeRange === "custom" && customRangeConfirm === false) {
      return;
    }
    setCustomRangeConfirm(false);
    if (homeController) homeController.abort();
    if (wafdashController) wafdashController.abort();
    if (websiteController) websiteController.abort();
    if (wafeventController) wafeventController.abort();
    if (planController) planController.abort();
    if (siteID) {
      getBotScoreStats(setWafEventController, siteID, getTimeRange());
    }
  }, [isAuthenticated, siteID, timeRange, customDateRange, curProjectId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (timeRange === "custom" && customRangeConfirm === false) {
      return;
    }
    setCustomRangeConfirm(false);
  }, [customRangeConfirm, timeRange]);

  const handleDetail = (categoryId, data) => {
    navigate("/v2/detection/bot_event", {
      state: {
        initialFilters: buildBotEventFiltersFromDashboardCard(categoryId, data),
        timeRange: getTimeRange(),
      },
    });
  };

  return (
    <>
      <Helmet title="Bot Managment Dashboard" />
      <Stack spacing={3} sx={{ p: 6 }}>
        <V2PageHeader
          title="Bot Management Dashboard"
          sx={{ pb: 0 }}
          actions={(
            <GreenTimeRangePicker
              selectPeriod={selectPeriod}
              selectCustomDateRange={selectCustomDateRange}
              timeRange={timeRange}
              customDateRange={customDateRange}
            />
          )}
        />
        <SiteScopeGate mode="any">
          {() => (
            <>
        <Box sx={{ width: "100%" }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Stack sx={{ height: 308, width: "100%", borderRadius: "8px", border: `1px solid ${colors.neutral[200]}`, p: 4 }}>
                <Typography
                  sx={ { fontSize: 14, lineHeight: "21px", fontWeight: "medium", color: colors.neutral[1000] }}
                >
                  Bot detections by country
                </Typography>
                <WorldVectorMap regional_detections={map_region} />
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack sx={{ height: 308, width: "100%", borderRadius: "8px", border: `1px solid ${colors.neutral[200]}`, p: 4 }}>
                <Typography
                  sx={ { fontSize: 14, lineHeight: "21px", fontWeight: "medium", color: colors.neutral[1000] }}
                >
                  Bot detection insights
                </Typography>
                <BotScoreStatsChart
                  setCustomRangeConfirm={setCustomRangeConfirm}
                  setTimeRange={setTimeRange}
                  setCustomDateRange={setCustomDateRange}
                />
              </Stack>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ width: "100%" }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} lg={4}>
              <Stack sx={{ borderRadius: "8px", border: `solid 1px ${colors.neutral[200]}`, p: 2, height: "-webkit-fill-available" }}>
                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={3} sx={{ py: 2 }}>
                  <Typography
                    sx={ { fontSize: 14, lineHeight: "21px", fontWeight: "medium", color: colors.neutral[1000], pl: 2 }}
                  >
                    Top detections by country
                  </Typography>
                </Stack>
                <Box sx={{ width: "100%" }}>
                  <Grid container>
                    {top_region === null && <PanelSkeleton />}
                    {top_region !== null && top_region.length === 0 && <DashboardPanelEmptyState />}
                    {top_region?.slice(0, DASHBOARD_TOP_CARD_LIMIT)?.map((item, index) => (
                      <Grid key={`top_waf_detections_by_country_${index}`} item xs={12}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          justifyContent={"space-between"}
                          spacing={3}
                          onClick={() => handleDetail("country", item?.country_iso_code)}
                          sx={{
                            p: 2,
                            borderRadius: "8px",
                            height: 42,
                            "&:hover": { backgroundColor: colors.primary["alpha"] },
                            cursor: "pointer",
                          }}
                        >
                          <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                            <ReactCountryFlag
                              countryCode={item?.country_iso_code}
                              svg
                              style={{
                                width: "26px",
                                height: "18px",
                              }}
                            />
                            <Typography sx={ { fontSize: 14, lineHeight: "21px", color: colors.neutral[1000] }}>
                              {regionNames.of(item?.country_iso_code)}
                            </Typography>
                          </Stack>
                          <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                            <LayerdIcon icon={DETECTION_ICONS.detection} size={18} color="neutral" />
                            <Typography sx={ { fontSize: 14, lineHeight: "21px", color: colors.neutral[600], pr: 3 }}>
                              {item.count}
                            </Typography>
                            <LayerdIcon icon={DETECTION_ICONS.view} size={18} color="neutral" />
                          </Stack>
                        </Stack>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} lg={4}>
              <Stack sx={{ borderRadius: "8px", border: `solid 1px ${colors.neutral[200]}`, p: 2, height: "-webkit-fill-available" }}>
                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={3} sx={{ py: 2 }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      lineHeight: "21px",
                      fontWeight: "medium",
                      color: colors.neutral[1000],
                      pl: 2,
                    }}
                  >
                    Top user agent
                  </Typography>
                </Stack>
                <Box sx={{ width: "100%" }}>
                  <Grid container>
                    {top_ua === null && <PanelSkeleton />}
                    {top_ua !== null && top_ua.length === 0 && <DashboardPanelEmptyState />}
                    {top_ua?.slice(0, DASHBOARD_TOP_CARD_LIMIT)?.map((item, index) => (
                      <Grid key={`top_user_agent${index}`} item xs={12}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          justifyContent={"space-between"}
                          spacing={3}
                          onClick={() => handleDetail("ua", item?.ua)}
                          sx={{
                            p: 2,
                            borderRadius: "8px",
                            height: 42,
                            "&:hover": { backgroundColor: colors.primary["alpha"] },
                            cursor: "pointer",
                          }}
                        >
                          <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                            <Typography
                              sx={{
                                fontSize: 14,
                                lineHeight: "21px",
                                color: colors.neutral[1000],
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: `calc(33vw - 180px)`,
                              }}
                            >
                              {displayUserAgent(item?.ua)}
                            </Typography>
                          </Stack>
                          <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                            <LayerdIcon icon={DETECTION_ICONS.detection} size={18} color="neutral" />
                            <Typography sx={ { fontSize: 14, lineHeight: "21px", color: colors.neutral[600], pr: 3 }}>
                              {item.count}
                            </Typography>
                            <LayerdIcon icon={DETECTION_ICONS.view} size={18} color="neutral" />
                          </Stack>
                        </Stack>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} lg={4}>
              <Stack sx={{ borderRadius: "8px", border: `solid 1px ${colors.neutral[200]}`, p: 2, height: "-webkit-fill-available" }}>
                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={3} sx={{ py: 2 }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      lineHeight: "21px",
                      fontWeight: "medium",
                      color: colors.neutral[1000],
                      pl: 2,
                    }}
                  >
                    Top paths
                  </Typography>
                </Stack>
                <Box sx={{ width: "100%" }}>
                  <Grid container>
                    {top_path === null && <PanelSkeleton />}
                    {top_path !== null && top_path.length === 0 && <DashboardPanelEmptyState />}
                    {top_path?.slice(0, DASHBOARD_TOP_CARD_LIMIT)?.map((item, index) => (
                      <Grid key={`top_user_agent${index}`} item xs={12}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          justifyContent={"space-between"}
                          spacing={3}
                          onClick={() => handleDetail("uri", item?.path)}
                          sx={{
                            p: 2,
                            borderRadius: "8px",
                            height: 42,
                            "&:hover": { backgroundColor: colors.primary["alpha"] },
                            cursor: "pointer",
                          }}
                        >
                          <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                            <Typography
                              sx={{
                                fontSize: 14,
                                lineHeight: "21px",
                                color: colors.neutral[1000],
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: `calc(33vw - 180px)`,
                              }}
                            >
                              {item.path}
                            </Typography>
                          </Stack>
                          <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                            <LayerdIcon icon={DETECTION_ICONS.detection} size={18} color="neutral" />
                            <Typography sx={ { fontSize: 14, lineHeight: "21px", color: colors.neutral[600], pr: 3 }}>
                              {item.count}
                            </Typography>
                            <LayerdIcon icon={DETECTION_ICONS.view} size={18} color="neutral" />
                          </Stack>
                        </Stack>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} lg={4}>
              <Stack sx={{ borderRadius: "8px", border: `solid 1px ${colors.neutral[200]}`, p: 2, height: "-webkit-fill-available" }}>
                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={3} sx={{ py: 2 }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      lineHeight: "21px",
                      fontWeight: "medium",
                      color: colors.neutral[1000],
                      pl: 2,
                    }}
                  >
                    Top events by source
                  </Typography>
                </Stack>
                <Box sx={{ width: "100%" }}>
                  <Grid container>
                    {top_source === null && <PanelSkeleton />}
                    {top_source !== null && top_source.length === 0 && <DashboardPanelEmptyState />}
                    {top_source?.slice(0, DASHBOARD_TOP_CARD_LIMIT)?.map((item, index) => (
                      <Grid key={`top_user_agent${index}`} item xs={12}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          justifyContent={"space-between"}
                          onClick={() => handleDetail("source_ip", item?.addr)}
                          spacing={3}
                          sx={{
                            p: 2,
                            borderRadius: "8px",
                            height: 42,
                            "&:hover": { backgroundColor: colors.primary["alpha"] },
                            cursor: "pointer",
                          }}
                        >
                          <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                            <Typography
                              sx={{
                                fontSize: 14,
                                lineHeight: "21px",
                                color: colors.neutral[1000],
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: `calc(33vw - 180px)`,
                              }}
                            >
                              {item.addr}
                            </Typography>
                          </Stack>
                          <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                            <LayerdIcon icon={DETECTION_ICONS.detection} size={18} color="neutral" />
                            <Typography sx={ { fontSize: 14, lineHeight: "21px", color: colors.neutral[600], pr: 3 }}>
                              {item.count}
                            </Typography>
                            <LayerdIcon icon={DETECTION_ICONS.view} size={18} color="neutral" />
                          </Stack>
                        </Stack>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} lg={4}>
              <Stack sx={{ borderRadius: "8px", border: `solid 1px ${colors.neutral[200]}`, p: 2, height: "-webkit-fill-available" }}>
                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={3} sx={{ py: 2 }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      lineHeight: "21px",
                      fontWeight: "medium",
                      color: colors.neutral[1000],
                      pl: 2,
                    }}
                  >
                    Top methods
                  </Typography>
                </Stack>
                <Box sx={{ width: "100%" }}>
                  <Grid container>
                    {top_method === null && <PanelSkeleton />}
                    {top_method !== null && top_method.length === 0 && <DashboardPanelEmptyState />}
                    {top_method?.slice(0, DASHBOARD_TOP_CARD_LIMIT)?.map((item, index) => (
                      <Grid key={`top_user_agent${index}`} item xs={12}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          justifyContent={"space-between"}
                          spacing={3}
                          onClick={() => handleDetail("method", item?.method)}
                          sx={{
                            p: 2,
                            borderRadius: "8px",
                            height: 42,
                            "&:hover": { backgroundColor: colors.primary["alpha"] },
                            cursor: "pointer",
                          }}
                        >
                          <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                            <Typography
                              sx={{
                                fontSize: 14,
                                lineHeight: "21px",
                                color: colors.neutral[1000],
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: `calc(33vw - 180px)`,
                              }}
                            >
                              {item.method}
                            </Typography>
                          </Stack>
                          <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                            <LayerdIcon icon={DETECTION_ICONS.detection} size={18} color="neutral" />
                            <Typography sx={ { fontSize: 14, lineHeight: "21px", color: colors.neutral[600], pr: 3 }}>
                              {item.count}
                            </Typography>
                            <LayerdIcon icon={DETECTION_ICONS.view} size={18} color="neutral" />
                          </Stack>
                        </Stack>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} lg={4}>
              <Stack sx={{ borderRadius: "8px", border: `solid 1px ${colors.neutral[200]}`, p: 2, height: "-webkit-fill-available" }}>
                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={3} sx={{ py: 2 }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      lineHeight: "21px",
                      fontWeight: "medium",
                      color: colors.neutral[1000],
                      pl: 2,
                    }}
                  >
                    Top hosts
                  </Typography>
                </Stack>
                <Box sx={{ width: "100%" }}>
                  <Grid container>
                    {top_host === null && <PanelSkeleton />}
                    {top_host !== null && top_host.length === 0 && <DashboardPanelEmptyState />}
                    {top_host?.slice(0, DASHBOARD_TOP_CARD_LIMIT)?.map((item, index) => (
                      <Grid key={`top_user_agent${index}`} item xs={12}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          justifyContent={"space-between"}
                          spacing={3}
                          onClick={() => handleDetail("host", item?.host)}
                          sx={{
                            p: 2,
                            borderRadius: "8px",
                            height: 42,
                            "&:hover": { backgroundColor: colors.primary["alpha"] },
                            cursor: "pointer",
                          }}
                        >
                          <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                            <Typography
                              sx={{
                                fontSize: 14,
                                lineHeight: "21px",
                                color: colors.neutral[1000],
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: `calc(33vw - 180px)`,
                              }}
                            >
                              {item.host}
                            </Typography>
                          </Stack>
                          <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                            <LayerdIcon icon={DETECTION_ICONS.detection} size={18} color="neutral" />
                            <Typography sx={ { fontSize: 14, lineHeight: "21px", color: colors.neutral[600], pr: 3 }}>
                              {item.count}
                            </Typography>
                            <LayerdIcon icon={DETECTION_ICONS.view} size={18} color="neutral" />
                          </Stack>
                        </Stack>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} lg={4}>
              <Stack sx={{ borderRadius: "8px", border: `solid 1px ${colors.neutral[200]}`, p: 2, height: "-webkit-fill-available" }}>
                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={3} sx={{ py: 2 }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      lineHeight: "21px",
                      fontWeight: "medium",
                      color: colors.neutral[1000],
                      pl: 2,
                    }}
                  >
                    Top JA3 fingerprints
                  </Typography>
                </Stack>
                <Box sx={{ width: "100%" }}>
                  <Grid container>
                    {top_ja3_hash === null && <PanelSkeleton />}
                    {top_ja3_hash !== null && top_ja3_hash.length === 0 && <DashboardPanelEmptyState />}
                    {top_ja3_hash?.slice(0, DASHBOARD_TOP_CARD_LIMIT)?.map((item, index) => (
                      <Grid key={`top_user_agent${index}`} item xs={12}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          justifyContent={"space-between"}
                          spacing={3}
                          onClick={() => handleDetail("ja3_hash", item?.ja3_hash)}
                          sx={{
                            p: 2,
                            borderRadius: "8px",
                            height: 42,
                            "&:hover": { backgroundColor: colors.primary["alpha"] },
                            cursor: "pointer",
                          }}
                        >
                          <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                            <Typography
                              sx={{
                                fontSize: 14,
                                lineHeight: "21px",
                                color: colors.neutral[1000],
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: `calc(33vw - 180px)`,
                              }}
                            >
                              {item.ja3_hash}
                            </Typography>
                          </Stack>
                          <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                            <LayerdIcon icon={DETECTION_ICONS.detection} size={18} color="neutral" />
                            <Typography sx={ { fontSize: 14, lineHeight: "21px", color: colors.neutral[600], pr: 3 }}>
                              {item.count}
                            </Typography>
                            <LayerdIcon icon={DETECTION_ICONS.view} size={18} color="neutral" />
                          </Stack>
                        </Stack>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </Box>
            </>
          )}
        </SiteScopeGate>
      </Stack>
      <StyledMenu
        MenuListProps={{ "aria-labelledby": "demo-customized-button" }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <PeriodItemComponent selectPeriod={selectPeriod} />
      </StyledMenu>
    </>
  );
};
export default NewServicesBotDashboard;
